module.exports = __webpack_public_path__ + "img/camera.7816bb71.png";